// redux
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import api from "../config/api";
import config from "../config/config";
import { getCurrentLoggedInSessionToken, getCurrentLoggedInSessionTokenWithPromise } from "../config/userPool";

const {
  EMPLOYEE_CONCERN_LISTING_ENDPOINT,
  EMPLOYEE_CONCERN_UPDATE_STATUS_ENDPOINT,
  EMPLOYEE_CONCERN_DETAIL_ENDPOINT,
  EMPLOYEE_CONCERN_EXPORT_ENDPOINT,
  AUDIT_ENDPOINT,
} = config.api_endpoint;

const initialState = {
  loading: false,
  employee_concern_list: [],
  detail_loading: false,
  employee_concern_detail: {},
  error: null,
  audit_data: [],
};

export const fetchAllEmployeeConcernList = createAsyncThunk(
  "hr_connect/fetchAllEmployeeConcernList",
  async (data, { rejectWithValue }) => {
    try {
      const token = getCurrentLoggedInSessionToken();
      const url = `${EMPLOYEE_CONCERN_LISTING_ENDPOINT}`;
      const results = await api.get(url, { ...data }, token);

      return results;
    } catch (error) {
      return rejectWithValue(error.details);
    }
  }
);


export const fetchEmployeeConcernExportList = createAsyncThunk(
  "hr_connect/fetchEmployeeConcernExportList",
  async (data, { rejectWithValue }) => {
    try {
      const token = getCurrentLoggedInSessionToken();
      const url = `${EMPLOYEE_CONCERN_EXPORT_ENDPOINT}`;
      const results = await api.get(url, {...data}, token);

      return results;
    } catch (error) {
      return rejectWithValue(error.details);
    }
  }
);



export const updateEmployeeConcernStatus = createAsyncThunk(
  "hr_connect/updateEmployeeConcernStatus",
  async ({ data, id }, { rejectWithValue }) => {
    try {
      const token = getCurrentLoggedInSessionToken();
      const results = await api.post(
        `${EMPLOYEE_CONCERN_UPDATE_STATUS_ENDPOINT}`,
        JSON.stringify(data),
        `Bearer ${token}`
      );

      return results;
    } catch (error) {
      return rejectWithValue(error.details);
    }
  }
);


export const fetchEmployeeConcernDetail = createAsyncThunk(
  "hr_connect/fetchEmployeeConcernDetail",
  async (id, { rejectWithValue }) => {
    try {
      const token = getCurrentLoggedInSessionToken();
      const results = await api.get(
        EMPLOYEE_CONCERN_DETAIL_ENDPOINT + "?id=" + id,
        {},
        `Bearer ${token}`
      );

      return results;
    } catch (error) {
      return rejectWithValue(error.details);
    }
  }
);



export const fetchEmployeeConcernAudit = createAsyncThunk(
  "hr_connect/fetchEmployeeConcernAudit",
  async (id, { rejectWithValue }) => {
    try {
      const token = await getCurrentLoggedInSessionTokenWithPromise();
      const results = await api.get(
        `${AUDIT_ENDPOINT}?table_name=employee-concern&source_id=${id}`,
        {},
        token
      );
      return results;
    } catch (err) {
      return rejectWithValue(err.details);
    }
  }
);


const employeeConcernSlice = createSlice({
  name: "employeeConcernList",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(updateEmployeeConcernStatus.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateEmployeeConcernStatus.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(updateEmployeeConcernStatus.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(fetchAllEmployeeConcernList.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAllEmployeeConcernList.fulfilled, (state, action) => {
        state.loading = false;
        state.employee_concern_list = action.payload;
      })
      .addCase(fetchAllEmployeeConcernList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(fetchEmployeeConcernDetail.pending, (state) => {
        state.detail_loading = true;
      })
      .addCase(fetchEmployeeConcernDetail.fulfilled, (state, action) => {
        state.detail_loading = false;
        state.employee_concern_detail = action.payload;
      })
      .addCase(fetchEmployeeConcernDetail.rejected, (state, action) => {
        state.detail_loading = false;
        state.error = action.error.message;
      })
      .addCase(fetchEmployeeConcernAudit.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchEmployeeConcernAudit.fulfilled, (state, action) => {
        state.loading = false;
        state.audit_data = action.payload.data;
      })
      .addCase(fetchEmployeeConcernAudit.rejected, (state, action) => {
        state.loading = true;
        state.error = action.error.message;
      })

  },
});

const employeeConcernReducer = employeeConcernSlice.reducer;
export default employeeConcernReducer;
